const initialState = []

const updateMergedTransaction = (array, merged_token_ids, merged_transaction) => {
  // Indexes of merged transactions
  var indexes = []
  array.map( (item, index) => {
    // Check if merged_token_ids contains the item
    if (merged_token_ids.indexOf(item.token_id) > -1) {
        // Don't return this transaction, it's one of the ones we merged
        indexes.push(index)
    }
  })
  // USE MAX: Keep the index of the oldesest transaction, the backend saves the newly combined transaction with the oldest date of the merged transactions
  // .max is not working well, reverting back to min
  var insert_at_index = Math.min(...indexes)

  // Remove merged transactions from array
  var newArray = array.filter( (item, index) => !merged_token_ids.includes(item.token_id) );

  // Insert newly merged transaction in proper position
  newArray.splice(insert_at_index, 0, merged_transaction)

  return newArray
}

const updateTransaction = (array, action) => {
  return array.map((transaction, index)=>{
    if (transaction.token_id === action.transaction.token_id) {
      return {
        ...transaction,
        ...action.transaction,
      }
    }
    return transaction
  })
}
const updateTransactions = (array, action) => {
  var updated_token_ids = action.transactions.map((transaction) => transaction.token_id)
  return array.map((transaction, index)=>{
    if (updated_token_ids.includes(transaction.token_id)) {
      return {
        ...transaction,
        ...action.transactions.filter((updated_transaction)=>updated_transaction.token_id==transaction.token_id)[0],
      }
    }
    return transaction
  })
}


export default function transactions(state=initialState, action) {
  switch (action.type) {

    // case "CREATE_INSTITUTION_USER_SUCCESS":
    // case 'TOGGLE_INSTITUTION_ACCOUNT_SUCCESS':
    //   return action.payload.transactions

    case 'GET_TRANSACTIONS_SUCCESS':
      return [
        ...action.user.transactions
      ]

    case 'NEW_TRANSACTION_ADDED':
      return [
        action.transaction,
        ...state
      ]

    case 'LOGIN_SUCCESS':
    case 'USER_SUCCESS':
      const transactions = action.user.transactions

      return [
        ...state,
        ...transactions,
      ]

    case 'LOGOUT_SUCCESS':
      return initialState

    case 'UPDATE_TRANSACTION_SUCCESS':
      return updateTransaction(state, action)
    case 'UPDATE_TRANSACTION_BATCH_SUCCESS':
      return updateTransactions(state, action)

    case 'REMOVE_TXN':
      return state.filter(txn=>txn.token_id!==action.transaction.token_id)

    case 'GET_MORE_TRANSACTIONS_SUCCESS':
      const moreTransactions = action.user.transactions
      return [
          ...state,
          ...moreTransactions
        ]

    case 'MERGE_TRANSACTIONS_SUCCESS':
      return updateMergedTransaction(state, action.token_ids, action.merged_transaction)

    case 'DELETE_TRANSACTIONS_SUCCESS':
      return state.filter( transaction =>
        !action.token_ids.includes(transaction.token_id)
      )

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/models/transactions.js